import React from 'react'
import StandardCards from '../components/StandardCards'

export default function Home() {
    return <StandardCards />
}